<template>
    <div class="ai-index">
        <h1>AI智能助手</h1>
    </div>
</template>
<script>
export default {
    name: "AiIndex",
}
</script>
<style scoped lang="scss">
.ai-index {
    padding: 20px;
}
</style>